// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/ChatbotAdminPanel/ChatbotAdminPanel.css */

/* Main container for the admin panel */
.chatbot-admin-panel {
  display: flex;
  flex-direction: column;
  padding: 20px;
  font-family: Arial, sans-serif;
  background-color: #f1f3f5;
  color: #333;
}

/* Toggle buttons at the top */
.admin-panel-toggle {
  display: flex;
  gap: 12px;
  margin-bottom: 20px;
}

.admin-panel-toggle button {
  flex: 1 1;
  padding: 12px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  border: none;
  background-color: #495057;
  color: #ffffff;
  border-radius: 6px;
  transition: background-color 0.3s ease, transform 0.1s ease;
}

.admin-panel-toggle button:hover {
  background-color: #343a40;
  transform: translateY(-2px);
}

/* Responsive grid layout for items */
.admin-panel-content {
  display: grid;
  grid-template-columns: 1fr;
  gap: 15px;
  margin-bottom: 20px;
  overflow-y: auto;
}

/* Adjust grid to two columns for larger screens */
@media (min-width: 1024px) {
  .admin-panel-content {
    grid-template-columns: 1fr 1fr;
  }
}

/* Styling for each item in the list */
.admin-panel-item {
  padding: 20px;
  background-color: #ffffff;
  border: 1px solid #d0d7de;
  border-radius: 6px;
  transition: box-shadow 0.3s ease;
  color: #495057;
  font-size: 16px;
}

.admin-panel-item:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.admin-panel-item div {
  margin-bottom: 10px;
  font-size: 16px;
}

/* Edit and Delete button styling inside each item */
.admin-panel-item-buttons {
  display: flex;
  gap: 12px;
  margin-top: 10px;
}

.admin-panel-item-buttons button {
  padding: 8px 16px;
  cursor: pointer;
  border: none;
  color: #ffffff;
  border-radius: 4px;
  font-size: 15px;
  font-weight: 600;
  transition: background-color 0.2s ease;
}

.admin-panel-item-buttons button:first-of-type {
  background-color: #e03131;
}

.admin-panel-item-buttons button:first-of-type:hover {
  background-color: #c92a2a;
}

.admin-panel-item-buttons button:last-of-type {
  background-color: #37b24d;
}

.admin-panel-item-buttons button:last-of-type:hover {
  background-color: #2b8a3e;
}

/* Add new item form */
.admin-panel-add {
  padding: 15px;
  background-color: #ffffff;
  border: 1px solid #d0d7de;
  border-radius: 6px;
}

.admin-panel-add h4 {
  margin-bottom: 15px;
  font-size: 18px;
  color: #212529;
}

.admin-panel-add label {
  display: block;
  margin-top: 10px;
  font-weight: 500;
  color: #495057;
}

.admin-panel-add input {
  width: calc(100% - 10px);
  padding: 10px;
  margin: 8px 0;
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 15px;
  color: #495057;
}

.admin-panel-add button {
  width: 100%;
  padding: 12px;
  background-color: #495057;
  color: #ffffff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  margin-top: 12px;
  font-weight: 600;
  transition: background-color 0.3s ease;
}

.admin-panel-add button:hover {
  background-color: #343a40;
}

/* Inline edit form styling */
.admin-panel-edit-form {
  padding: 20px;
  background-color: #f8f9fa;
  border: 1px solid #ccc;
  border-radius: 8px;
  margin-top: 10px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

/* Input fields in the edit form */
.admin-panel-edit-form input {
  width: 100%;
  padding: 10px;
  margin: 8px 0;
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 16px;
  background-color: #ffffff;
  color: #495057;
}

/* Save and Cancel buttons in the edit form */
.admin-panel-edit-form button {
  padding: 8px 16px;
  margin-right: 10px;
  border: none;
  border-radius: 5px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.admin-panel-edit-form button.save-button {
  background-color: #37b24d;
  color: #ffffff;
}

.admin-panel-edit-form button.save-button:hover {
  background-color: #2b8a3e;
}

.admin-panel-edit-form button.cancel-button {
  background-color: #e03131;
  color: #ffffff;
}

.admin-panel-edit-form button.cancel-button:hover {
  background-color: #c92a2a;
}

/* Responsive styling */
@media (max-width: 768px) {
  .admin-panel-toggle button {
    font-size: 14px;
    padding: 8px;
  }

  .admin-panel-item, .admin-panel-add, .admin-panel-edit-form {
    padding: 15px;
  }

  .admin-panel-content {
    max-height: 400px;
  }
}

@media (max-width: 480px) {
  .chatbot-admin-panel {
    padding: 15px;
  }

  .admin-panel-toggle {
    flex-direction: column;
    gap: 8px;
  }

  .admin-panel-item, .admin-panel-add, .admin-panel-edit-form {
    font-size: 15px;
    padding: 12px;
  }

  .admin-panel-item div {
    font-size: 15px;
  }

  .admin-panel-edit-form input,
  .admin-panel-add input {
    font-size: 15px;
    padding: 8px;
  }
}

/* Status Alert Styling */
.alert {
  margin-bottom: 15px;
  padding: 10px 15px;
  border-radius: 5px;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
}

.alert.success {
  background-color: #37b24d;
  color: #ffffff;
}

.alert.error {
  background-color: #e03131;
  color: #ffffff;
}
`, "",{"version":3,"sources":["webpack://./src/MyComponents/ChatBot/ChatbotAdminPanel.css"],"names":[],"mappings":"AAAA,2DAA2D;;AAE3D,uCAAuC;AACvC;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,8BAA8B;EAC9B,yBAAyB;EACzB,WAAW;AACb;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,2DAA2D;AAC7D;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,kDAAkD;AAClD;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA,oDAAoD;AACpD;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,aAAa;EACb,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA,kCAAkC;AAClC;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,cAAc;AAChB;;AAEA,6CAA6C;AAC7C;EACE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,uBAAuB;AACvB;EACE;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,eAAe;IACf,YAAY;EACd;AACF;;AAEA,yBAAyB;AACzB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB","sourcesContent":["/* src/components/ChatbotAdminPanel/ChatbotAdminPanel.css */\n\n/* Main container for the admin panel */\n.chatbot-admin-panel {\n  display: flex;\n  flex-direction: column;\n  padding: 20px;\n  font-family: Arial, sans-serif;\n  background-color: #f1f3f5;\n  color: #333;\n}\n\n/* Toggle buttons at the top */\n.admin-panel-toggle {\n  display: flex;\n  gap: 12px;\n  margin-bottom: 20px;\n}\n\n.admin-panel-toggle button {\n  flex: 1;\n  padding: 12px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  border: none;\n  background-color: #495057;\n  color: #ffffff;\n  border-radius: 6px;\n  transition: background-color 0.3s ease, transform 0.1s ease;\n}\n\n.admin-panel-toggle button:hover {\n  background-color: #343a40;\n  transform: translateY(-2px);\n}\n\n/* Responsive grid layout for items */\n.admin-panel-content {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 15px;\n  margin-bottom: 20px;\n  overflow-y: auto;\n}\n\n/* Adjust grid to two columns for larger screens */\n@media (min-width: 1024px) {\n  .admin-panel-content {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n\n/* Styling for each item in the list */\n.admin-panel-item {\n  padding: 20px;\n  background-color: #ffffff;\n  border: 1px solid #d0d7de;\n  border-radius: 6px;\n  transition: box-shadow 0.3s ease;\n  color: #495057;\n  font-size: 16px;\n}\n\n.admin-panel-item:hover {\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.admin-panel-item div {\n  margin-bottom: 10px;\n  font-size: 16px;\n}\n\n/* Edit and Delete button styling inside each item */\n.admin-panel-item-buttons {\n  display: flex;\n  gap: 12px;\n  margin-top: 10px;\n}\n\n.admin-panel-item-buttons button {\n  padding: 8px 16px;\n  cursor: pointer;\n  border: none;\n  color: #ffffff;\n  border-radius: 4px;\n  font-size: 15px;\n  font-weight: 600;\n  transition: background-color 0.2s ease;\n}\n\n.admin-panel-item-buttons button:first-of-type {\n  background-color: #e03131;\n}\n\n.admin-panel-item-buttons button:first-of-type:hover {\n  background-color: #c92a2a;\n}\n\n.admin-panel-item-buttons button:last-of-type {\n  background-color: #37b24d;\n}\n\n.admin-panel-item-buttons button:last-of-type:hover {\n  background-color: #2b8a3e;\n}\n\n/* Add new item form */\n.admin-panel-add {\n  padding: 15px;\n  background-color: #ffffff;\n  border: 1px solid #d0d7de;\n  border-radius: 6px;\n}\n\n.admin-panel-add h4 {\n  margin-bottom: 15px;\n  font-size: 18px;\n  color: #212529;\n}\n\n.admin-panel-add label {\n  display: block;\n  margin-top: 10px;\n  font-weight: 500;\n  color: #495057;\n}\n\n.admin-panel-add input {\n  width: calc(100% - 10px);\n  padding: 10px;\n  margin: 8px 0;\n  border: 1px solid #ced4da;\n  border-radius: 4px;\n  font-size: 15px;\n  color: #495057;\n}\n\n.admin-panel-add button {\n  width: 100%;\n  padding: 12px;\n  background-color: #495057;\n  color: #ffffff;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  margin-top: 12px;\n  font-weight: 600;\n  transition: background-color 0.3s ease;\n}\n\n.admin-panel-add button:hover {\n  background-color: #343a40;\n}\n\n/* Inline edit form styling */\n.admin-panel-edit-form {\n  padding: 20px;\n  background-color: #f8f9fa;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  margin-top: 10px;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n}\n\n/* Input fields in the edit form */\n.admin-panel-edit-form input {\n  width: 100%;\n  padding: 10px;\n  margin: 8px 0;\n  border: 1px solid #ced4da;\n  border-radius: 4px;\n  font-size: 16px;\n  background-color: #ffffff;\n  color: #495057;\n}\n\n/* Save and Cancel buttons in the edit form */\n.admin-panel-edit-form button {\n  padding: 8px 16px;\n  margin-right: 10px;\n  border: none;\n  border-radius: 5px;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.admin-panel-edit-form button.save-button {\n  background-color: #37b24d;\n  color: #ffffff;\n}\n\n.admin-panel-edit-form button.save-button:hover {\n  background-color: #2b8a3e;\n}\n\n.admin-panel-edit-form button.cancel-button {\n  background-color: #e03131;\n  color: #ffffff;\n}\n\n.admin-panel-edit-form button.cancel-button:hover {\n  background-color: #c92a2a;\n}\n\n/* Responsive styling */\n@media (max-width: 768px) {\n  .admin-panel-toggle button {\n    font-size: 14px;\n    padding: 8px;\n  }\n\n  .admin-panel-item, .admin-panel-add, .admin-panel-edit-form {\n    padding: 15px;\n  }\n\n  .admin-panel-content {\n    max-height: 400px;\n  }\n}\n\n@media (max-width: 480px) {\n  .chatbot-admin-panel {\n    padding: 15px;\n  }\n\n  .admin-panel-toggle {\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  .admin-panel-item, .admin-panel-add, .admin-panel-edit-form {\n    font-size: 15px;\n    padding: 12px;\n  }\n\n  .admin-panel-item div {\n    font-size: 15px;\n  }\n\n  .admin-panel-edit-form input,\n  .admin-panel-add input {\n    font-size: 15px;\n    padding: 8px;\n  }\n}\n\n/* Status Alert Styling */\n.alert {\n  margin-bottom: 15px;\n  padding: 10px 15px;\n  border-radius: 5px;\n  font-size: 16px;\n  font-weight: bold;\n  text-align: center;\n}\n\n.alert.success {\n  background-color: #37b24d;\n  color: #ffffff;\n}\n\n.alert.error {\n  background-color: #e03131;\n  color: #ffffff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
